export const calculateTestScoresSATdelta = (subjectScores: SubjectScore[]): number => {
  return subjectScores.reduce((total, curr) => total + curr.delta, 0);
};

export const calculateTestScoresACTdelta = (subjectScores: SubjectScore[]): number => {
  return Math.round(
    subjectScores.reduce((total, curr) => total + curr.delta, 0) / subjectScores.length
  );
};
